import React, { createContext, useContext, useState, useEffect } from "react";

// Create the context
const DirectionContext = createContext();

// Create a provider component
export const DirectionProvider = ({ children }) => {
  const [direction, setDirection] = useState("horizontal");

  useEffect(() => {
    const handleResize = () => {
      setDirection(window.innerWidth <= 800 ? "vertical" : "horizontal");
    };

    // Set initial direction
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <DirectionContext.Provider value={direction}>
      {children}
    </DirectionContext.Provider>
  );
};

// Custom hook to use the context
export const useDirection = () => useContext(DirectionContext);
